import type { TransactionTag } from '@/types';
import { categoryChipStyleFromColor, hashToCategoryColor, type CategoryChipStyle } from './categories';

/** Rows show at most this many pills; the rest collapse into a "+N" overflow. */
export const MAX_ROW_TAG_PILLS = 2;

/**
 * THE tag color: the stored hex when the backoffice/user picked one, otherwise the same
 * deterministic hash palette categories use — prefixed so a tag and a category with the
 * same id can never collide into the same hue by accident.
 */
export function tagColor(tag: Pick<TransactionTag, 'id' | 'color'>): string {
  return tag.color?.trim() ? tag.color : hashToCategoryColor(`tag:${tag.id}`);
}

/** Pill styling through the category `color-mix` derivation — theme-reactive for free. */
export function tagChipStyle(tag: Pick<TransactionTag, 'id' | 'color'>): CategoryChipStyle {
  return categoryChipStyleFromColor(tagColor(tag));
}

/**
 * The pickers' two sections: "Suas tags" (personal, listed first) and "Tags da Vértice"
 * (global). The applied pill on a row is identical for both — scope only matters when
 * choosing/managing.
 */
export function splitTagsByScope(tags: readonly TransactionTag[]): {
  personal: TransactionTag[];
  global: TransactionTag[];
} {
  return {
    personal: tags.filter((t) => t.scope === 'personal'),
    global: tags.filter((t) => t.scope === 'global'),
  };
}
